﻿import React from "react";
import { useActivitiesData, useActivityItem } from "./ActivitiesDataContext";
import { withLayoutCommon, getLayoutCommonRootProps } from "@digitalopsdev/serviceops-docs-components/dist/blocks/LayoutCommonMixin";

type MetricType = "zone" | "duration" | "epoc" | "trimp";

const ActivityTile = {
    fields: {
        metric: {
            type: "select" as const,
            options: [
                { label: "Zone", value: "zone" },
                { label: "Duration", value: "duration" },
                { label: "EPOC", value: "epoc" },
                { label: "TRIMP", value: "trimp" },
            ],
        },
        label: { type: "text" as const },
        colorClass: { type: "text" as const },
    },
    defaultProps: {
        metric: "zone",
        label: "Zone",
        colorClass: "from-indigo-500 to-purple-600",
        padding: {
            mode: "set",
            input: "sym",
            setY: "1em",
            setX: "0.9375em"
        },
    },
    inline: true,
    render: (props: any) => {
        const { metric, label, colorClass, puck } = props as any;
        const { helpers } = useActivitiesData();
        const { item } = useActivityItem();

        let value: React.ReactNode = "—";
        switch (metric as MetricType) {
            case "zone":
                value = item.zoneLabel ?? "—";
                break;
            case "duration":
                value = helpers.formatDurationFromHours(
                    item.trainingLoad?.sessionDurationHours
                );
                break;
            case "epoc":
                value =
                    typeof item.epocTotal === "number"
                        ? Math.round(item.epocTotal).toString()
                        : "—";
                break;
            case "trimp": {
                const trimp = item.trainingLoad?.totalTRIMP;
                value =
                    typeof trimp === "number"
                        ? Math.round(trimp).toString()
                        : "—";
                break;
            }
        }

        return (
            <div
                ref={puck?.dragRef}
                {...getLayoutCommonRootProps(props, { className: `rounded-lg text-white bg-gradient-to-br ${colorClass}` })}
            >
                <div className="text-xl font-bold">{value}</div>
                <div className="text-xs opacity-90" style={{ textWrap: "balance" }}>{label}</div>
            </div>
        );
    },
};

export default withLayoutCommon(ActivityTile);
